import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import { DownloadIcon, PswdvisibleIcon } from "../../../assets/icons-components/Icons";
import CustomTooltip from "../../../components/CustomTooltip/CustomTooltip";
import FormModal from "../../../components/FormModal/FormModal";
import Buttons from "../../../components/Buttons/Buttons";

// Shared by the HealthCare and SuperAdmin patient-session views. SuperAdmin
// only shows the download action once a CSV actually exists for the row;
// HealthCare always shows it (disabled/spinning while processing).
const ReferenceDataModal = ({
  referenceData,
  processingSessionId,
  formatDate,
  formatDateOnly,
  onView,
  onDownload,
  onClose,
  requireCsvUrl = false,
}) => {
  return (
    <FormModal
      open
      onClose={onClose}
      title="Reference Data"
      maxWidth="md"
      actions={<Buttons text="Close" type="button" variant="smallsecondary" onClick={onClose} />}
    >
      <div className="table-container">
        <TableContainer component={Paper}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                <TableCell>SL No</TableCell>
                <TableCell>Start Time</TableCell>
                <TableCell>End Time</TableCell>
                <TableCell>Last Downloaded</TableCell>
                <TableCell>Download Limit</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {referenceData?.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>
                    {index + 1}
                  </TableCell>
                  <TableCell>
                    {formatDate(row?.startDate)} UTC
                  </TableCell>
                  <TableCell>
                    {formatDate(row?.endDate)} UTC
                  </TableCell>
                  <TableCell>
                    {row?.csvDownloadedDate
                      ? `${formatDateOnly(row.csvDownloadedDate)}`
                      : "-"}
                  </TableCell>
                  <TableCell>
                    {row?.csvDownloadCount ?? 0}/
                    {row?.maxCsvDownloadCount ?? 0}
                  </TableCell>
                  <TableCell>
                    <div
                      className="table_icons"
                      style={{ display: "flex", gap: "15px" }}
                    >
                      <CustomTooltip title="View">
                        <IconButton
                          aria-label="view"
                          onClick={() => onView(row)}
                        >
                          <PswdvisibleIcon />
                        </IconButton>
                      </CustomTooltip>

                      {(!requireCsvUrl || row.csvUrl) && (
                        <CustomTooltip
                          title={
                            row.processedCSVUrl && row.logFileUrl
                              ? "Download (ZIP with CSV + log)"
                              : "Download"
                          }
                        >
                          <span>
                            <IconButton
                              aria-label="download"
                              disabled={processingSessionId === row.id}
                              onClick={() => onDownload(row)}
                            >
                              {processingSessionId === row.id ? (
                                <CircularProgress size="20px" />
                              ) : (
                                <DownloadIcon />
                              )}
                            </IconButton>
                          </span>
                        </CustomTooltip>
                      )}

                      <CustomTooltip
                        title={`Reference ID: ${row.referenceId || "N/A"}`}
                      >
                        <IconButton aria-label="info">
                          <InfoOutlinedIcon />
                        </IconButton>
                      </CustomTooltip>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </FormModal>
  );
};

export default ReferenceDataModal;
